import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private authService: MsalService, private router: Router) {}

  async canActivate(): Promise<boolean> {
    const accounts = this.authService.instance.getAllAccounts();

    if (accounts.length > 0) {
      // User is authenticated
      return true;
    } else {
      // User is not authenticated, redirect to /login
      this.router.navigate(['/login']);
      return false;
    }
  }
}
